/* ============================================================
   MT — Interacciones de la tienda (vanilla, sin librerias).
   Cada init comprueba si su elemento existe: el mismo archivo
   sirve para todas las paginas.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll (stagger por grupo) ---- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    // Stagger: a cada elemento con data-mt-group le da un retardo por indice
    var groups = {};
    els.forEach(function (el) {
      var g = el.getAttribute('data-mt-group') || 'x';
      groups[g] = (groups[g] || 0);
      el.style.setProperty('--mt-delay', (groups[g] * 90) + 'ms');
      groups[g]++;
      io.observe(el);
    });
  }

  /* ---- Parallax suave del fondo del hero ---- */
  function initHeroParallax() {
    var img = document.querySelector('.mt-hero__bg img');
    if (!img || reduce) return;
    var ticking = false;
    function update() {
      var rect = img.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.06;
      img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.08)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Contadores (count-up) ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-count'));
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Carrusel de resenas: arrastrar + botones + auto ---- */
  function initReviews() {
    document.querySelectorAll('[data-mt-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.mt-rev__track');
      if (!track) return;
      var isDown = false, startX = 0, scrollStart = 0, moved = false;

      wrap.addEventListener('pointerdown', function (e) {
        isDown = true; moved = false;
        startX = e.clientX; scrollStart = wrap.scrollLeft;
        wrap.setPointerCapture(e.pointerId);
        wrap.classList.add('mt-grabbing');
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        wrap.scrollLeft = scrollStart - dx;
      });
      function up() { isDown = false; wrap.classList.remove('mt-grabbing'); }
      wrap.addEventListener('pointerup', up);
      wrap.addEventListener('pointercancel', up);
      wrap.addEventListener('pointerleave', up);
      wrap.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);

      var prev = wrap.parentNode.querySelector('[data-mt-prev]');
      var next = wrap.parentNode.querySelector('[data-mt-next]');
      function card() { var c = track.querySelector('.mt-rev__card'); return c ? c.offsetWidth + 20 : 360; }
      if (prev) prev.addEventListener('click', function () { wrap.scrollBy({ left: -card(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { wrap.scrollBy({ left: card(), behavior: 'smooth' }); });
    });
  }

  /* ---- Comparador antes/despues (deslizador) ---- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-mt-ba]').forEach(function (ba) {
      var after = ba.querySelector('.mt-ba__after');
      if (!after) return;
      ba.querySelectorAll('img').forEach(function (im) { im.setAttribute('draggable', 'false'); });
      function setPos(clientX) {
        var rect = ba.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        ba.style.setProperty('--mt-ba-pos', (p * 100) + '%');
      }
      var dragging = false;
      ba.addEventListener('dragstart', function (e) { e.preventDefault(); });
      ba.addEventListener('pointerdown', function (e) { dragging = true; try { ba.setPointerCapture(e.pointerId); } catch (err) {} setPos(e.clientX); e.preventDefault(); });
      ba.addEventListener('pointermove', function (e) { if (dragging) { setPos(e.clientX); e.preventDefault(); } });
      window.addEventListener('pointerup', function () { dragging = false; });
      ba.addEventListener('pointercancel', function () { dragging = false; });
      // Click en cualquier punto reposiciona (ademas del arrastre)
      ba.addEventListener('click', function (e) { setPos(e.clientX); });
    });
  }

  /* ---- Pagina de producto: galeria, cantidad, variantes ---- */
  function initProducto() {
    var pdp = document.querySelector('.mt-pdp');
    if (!pdp) return;

    // Galeria: miniaturas -> imagen principal (con soporte de 3D)
    var main = pdp.querySelector('[data-mt-main]');
    var thumb3d = pdp.querySelector('[data-mt-thumb-3d]');
    function clearActive() { pdp.querySelectorAll('.mt-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); }); }
    pdp.querySelectorAll('[data-mt-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-mt-src');
        if (main && src) { main.setAttribute('src', src); main.classList.remove('is-hidden'); }
        clearActive(); thumb.classList.add('is-active');
      });
    });
    if (thumb3d) {
      thumb3d.addEventListener('click', function () {
        if (main) main.classList.add('is-hidden');
        clearActive(); thumb3d.classList.add('is-active');
      });
    }

    // Cantidad
    var qty = pdp.querySelector('[data-mt-qty]');
    var minus = pdp.querySelector('[data-mt-qty-minus]');
    var plus = pdp.querySelector('[data-mt-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Boton de compra flotante: reutiliza el add-to-cart principal
    var stickyAddBtn = pdp.querySelector('[data-mt-sticky-add]');
    var stickyAddText = pdp.querySelector('[data-mt-sticky-add-text]');
    var stickyMainAdd = pdp.querySelector('[data-mt-add]');
    if (stickyAddBtn && stickyMainAdd) {
      stickyAddBtn.addEventListener('click', function () { if (!stickyAddBtn.disabled) stickyMainAdd.click(); });
    }

    // Variantes
    var picker = pdp.querySelector('[data-mt-variant-picker]');
    var dataEl = document.querySelector('[data-mt-variants]');
    if (picker && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var idInput = pdp.querySelector('[data-mt-variant-id]');
      var compareEl = pdp.querySelector('[data-mt-compare]');
      var offEl = pdp.querySelector('[data-mt-off]');
      var addBtn = pdp.querySelector('[data-mt-add]');
      var addText = pdp.querySelector('[data-mt-add-text]');

      function selectedOptions() {
        return Array.prototype.map.call(picker.querySelectorAll('[data-mt-opt]'), function (opt) {
          var active = opt.querySelector('.mt-pdp__swatch.is-active');
          return active ? active.getAttribute('data-mt-value') : null;
        });
      }
      function apply() {
        var sel = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        pdp.querySelectorAll('[data-mt-price]').forEach(function (pe) { pe.textContent = match.price; });
        if (compareEl) {
          if (match.has_compare) { compareEl.textContent = match.compare_at; compareEl.hidden = false; if (offEl) offEl.hidden = false; }
          else { compareEl.hidden = true; if (offEl) offEl.hidden = true; }
        }
        if (addBtn && addText) {
          addBtn.disabled = !match.available;
          addText.textContent = match.available ? addBtn.getAttribute('data-mt-add-label') || addText.textContent : 'Sold out';
        }
        if (stickyAddBtn) stickyAddBtn.disabled = !match.available;
        if (stickyAddText && addBtn) {
          stickyAddText.textContent = match.available ? (addBtn.getAttribute('data-mt-add-label') || stickyAddText.textContent) : 'Sold out';
        }
      }
      if (addBtn && addText) addBtn.setAttribute('data-mt-add-label', addText.textContent);
      picker.querySelectorAll('[data-mt-opt]').forEach(function (opt) {
        opt.querySelectorAll('.mt-pdp__swatch').forEach(function (sw) {
          sw.addEventListener('click', function () {
            opt.querySelectorAll('.mt-pdp__swatch').forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            var lbl = opt.querySelector('[data-mt-opt-selected]');
            if (lbl) lbl.textContent = sw.getAttribute('data-mt-value');
            apply();
          });
        });
      });
    }
  }

  /* ---- Barra de compra flotante: se muestra al perder de vista el boton principal ---- */
  function initStickyBar() {
    var bar = document.querySelector('[data-mt-stickybar]');
    if (!bar) return;
    var anchor = document.querySelector('.mt-pdp__form [data-mt-add]') || document.querySelector('[data-mt-add]');
    function show(v) { bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); }
    if (!anchor || !('IntersectionObserver' in window)) { show(true); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function boot() {
    initReveals();
    initHeroParallax();
    initCounters();
    initReviews();
    initBeforeAfter();
    initProducto();
    initStickyBar();
  }

  // Guard: el mismo archivo se incluye una vez por seccion. Sin esto, boot()
  // corre varias veces y los listeners (p. ej. el +/- de cantidad) se enganchan
  // duplicados y el contador salta de 2 en 2. Aseguramos un unico arranque.
  if (window.__mtBooted) return;
  window.__mtBooted = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
